<div>
  <input [disabled]="fg?.disabled ?? false" type="text" class="form-control" [required]="fg?.controls?.id?.hasValidator(reqValFn) ?? false" (focus)="onFocus()" (blur)="onBlur()" [(ngModel)]="vehicleModel" (selectItem)="addVehicle($event.item)"
    [ngbTypeahead]="search" [inputFormatter]="formatter" [resultFormatter]="formatter" [editable]='false' [placeholder]="placeholder" />
</div>
